import React from 'react';
import { ModalBase } from '@panel/commons';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';
import { getColor } from '@panel/commons/core/themev3';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.h4`
  height: 26px;
  margin: 14px 0px 4px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: ${select('black')};
`;

const Description = styled.p`
  width: 356px;
  height: 52px;
  margin-bottom: 36px;
  font-size: 16px;
  color: ${select('darkGray')};
  text-align: center;
  white-space: break-spaces;
`;

const TryAgain = styled.button`
  width: 176px;
  height: 48px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: ${select('white')};
  background-color: ${getColor('primary')};
  cursor: pointer;
`;

function DisabledBranchError({ openModal, onClose, handleClick }) {
  const { t } = useTranslation();

  return (
    <ModalBase openModal={openModal} onClose={onClose} width='355px' height='220px'>
      <Container data-repa='Modals-disabledBranchError-container'>
        <Title data-repa='Modals-disabledBranchError-container-title'>
          {t('publisher.modal.disabledBranch.title')}
        </Title>
        <Description data-repa='Modals-disabledBranchError-container-description'>
          {t('publisher.modal.disabledBranch.description')}
        </Description>
        <TryAgain data-repa='Modals-disabledBranchError-container-CTA' type='button' onClick={handleClick}>
          {t('publisher.modal.disabledBranch.button')}
        </TryAgain>
      </Container>
    </ModalBase>
  );
}

export { DisabledBranchError };
